export default __webpack_public_path__ + "static/media/pfpa.001176d7.jpg";